import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import '@fontsource/jost/300.css'
import '@fontsource/jost/400.css'
import '@fontsource/jost/500.css'
import '@fontsource/hanken-grotesk/400.css'
import '@fontsource/hanken-grotesk/500.css'
import '@fontsource/hanken-grotesk/600.css'
import '@fontsource/ibm-plex-mono/400.css'
import './styles/tokens.css'
import './styles/base.css'
import './styles/components.css'
import './styles/shell.css'
import './styles/portal-classic.css'
import './styles/auth.css'
import './styles/data.css'
import { AuthProvider } from './lib/auth'
import { RouterProvider } from './lib/router'
import { CrashGuard } from './lib/crash'
import { UpdateBar } from './lib/update-check'
import { App } from './App'
import { ChatDockGate } from './modules/comms/dock'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: true },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <CrashGuard>
      <QueryClientProvider client={queryClient}>
        <RouterProvider>
          <AuthProvider>
            <UpdateBar />
            <App />
            <ChatDockGate />
          </AuthProvider>
        </RouterProvider>
      </QueryClientProvider>
    </CrashGuard>
  </StrictMode>,
)
